// immutable empty array
export const EMPTY_ARRAY = Object.freeze([]);

// immutable empty object
export const EMPTY_OBJECT = Object.freeze({});
